// extracted by mini-css-extract-plugin
export default {"myBtn":"MyButton_myBtn__1fuf1"};